import { useCallback, useMemo, useState } from "react";
import { Flex, Box, Image, IconButton } from "@chakra-ui/react";

// react-icons
import { FiMenu } from "react-icons/fi";
import { AiOutlineMore } from "react-icons/ai";

import { HeaderContainer } from "theme";

// components
import SubHeader from "@components/Header/SubHeader";

import usePageData from "@hooks/usePageData";

import { trackEvent } from "@utils/firebase";

import { TERMS_OF_SERVICE, SUPPORT } from "@constants/analytics";
import { STADER_URL } from "@constants/constants";
import {
  StrapiLiquidStakingOptions,
  StrapiSubHeaderOption,
} from "@customtypes/global";

import { HeaderWalletConnect, useStakeProvider } from "dapp-sdk";

const Header = () => {
  const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);
  const { setMobileMenuVisible, firebaseEventsData } = useStakeProvider();

  const {
    page: { data: pageData },
  } = usePageData();
  const { sub_header_options } = pageData || { data: [] };

  const subHeaderOptions: StrapiSubHeaderOption[] = useMemo(() => {
    const options = sub_header_options?.data;
    return options?.map(
      (data: StrapiLiquidStakingOptions) => data?.attributes || []
    );
  }, [sub_header_options]);

  const headerMenuClick = useCallback(
    (key: string) => {
      let eventName = key;
      let eventParams = {};
      switch (key) {
        case "tos": {
          eventName = TERMS_OF_SERVICE;
          eventParams = {
            type: "header",
          };
          break;
        }
        case "support": {
          eventName = SUPPORT;
          break;
        }
      }
      if (eventName) {
        trackEvent(eventName, { ...eventParams, ...firebaseEventsData });
      }
    },
    [firebaseEventsData]
  );

  return (
    <>
      <HeaderContainer>
        <Box display={{ base: "inherit", xl: "none" }} alignItems="center">
          <IconButton
            display={{ base: "flex", xl: "none" }}
            onClick={() => setMobileMenuVisible(true)}
            aria-label="open menu"
            h="32px"
            w="32px"
            bg="transperent"
            icon={<FiMenu />}
          />
          <Box pl="1rem">
            <a href={STADER_URL}>
              <Image
                src={`${
                  process.env.NEXT_PUBLIC_SUB_ROUTE || ""
                }/assets/images/stader-icon.svg`}
                width="24px"
                height="24px"
                alt="stader-logo"
              />
            </a>
          </Box>
        </Box>

        <Box height={{ xl: "56px" }}>
          <Flex
            alignItems="center"
            position={{ xl: "fixed" }}
            right="0px"
            zIndex="1"
          >
            <HeaderWalletConnect />

            <IconButton
              variant="icon"
              alignItems="center"
              icon={<AiOutlineMore height="24px" width="24px" />}
              onClick={() => setIsSubMenuVisible(true)}
              aria-label="change theme"
              fontSize="20px"
              ml="4px"
              borderRadius="0.5rem"
              display={{ base: "flex", md: "none" }}
            />

            <SubHeader
              headerOptins={subHeaderOptions}
              shouldDisplayMenu={isSubMenuVisible}
              onChangeDisplayMenu={(isVisible) =>
                setIsSubMenuVisible(isVisible)
              }
              onSubHeaderMenuClick={headerMenuClick}
            />
          </Flex>
        </Box>
      </HeaderContainer>
    </>
  );
};

export default Header;
